"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageEmbedPlatforms = void 0;
exports.SetPageEmbedPlatforms = [
    'instagram',
    'tiktok',
    'facebook',
    'twitter',
];
//# sourceMappingURL=Embed.js.map